import { render, staticRenderFns } from "./FlatGuestBox.vue?vue&type=template&id=92c61c4e&scoped=true&"
import script from "./FlatGuestBox.vue?vue&type=script&lang=js&"
export * from "./FlatGuestBox.vue?vue&type=script&lang=js&"
import style0 from "./FlatGuestBox.vue?vue&type=style&index=0&id=92c61c4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c61c4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92c61c4e')) {
      api.createRecord('92c61c4e', component.options)
    } else {
      api.reload('92c61c4e', component.options)
    }
    module.hot.accept("./FlatGuestBox.vue?vue&type=template&id=92c61c4e&scoped=true&", function () {
      api.rerender('92c61c4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Kpz1URqTuh3J/JS/comp/FlatGuestBox.vue"
export default component.exports